import React from 'react'
// Components
import _Picker, { Props as _PickerProps } from './_Picker'

const DateTimePicker: React.FC<Omit<_PickerProps, 'picker'>> = (p) => (
  <_Picker {...p} picker={'datetime'} />
)

export default DateTimePicker
